import * as React from 'react';
import { isNumber, useStyles, isUndefined } from '@sravni/react-utils';
import modules_a7ef704f from '../styles/Col.module.less.js';

/** Helper function */
const convertSpanAdaptiveToClassNames = (span) => {
    if (isUndefined(span))
        return [];
    const breakpoints = Object.keys(span);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? span[breakpoint]
        : `${breakpoint}-${span[breakpoint]}`;
    return breakpoints.map((breakpoint) => `span-${createName(breakpoint)}`);
};
/** Helper function */
const convertOrderAdaptiveToClassNames = (order) => {
    if (isUndefined(order))
        return [];
    const breakpoints = Object.keys(order);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? order[breakpoint]
        : `${breakpoint}-${order[breakpoint]}`;
    return breakpoints.map((breakpoint) => `order-${createName(breakpoint)}`);
};
/** Helper function */
const convertOffsetAdaptiveToClassNames = (offset) => {
    if (isUndefined(offset))
        return [];
    const breakpoints = Object.keys(offset);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? offset[breakpoint]
        : `${breakpoint}-${offset[breakpoint]}`;
    return breakpoints.map((breakpoint) => `offset-${createName(breakpoint)}`);
};
/**
 * @description Column element for Grid system.
 *
 * @component
 * @example
 * ```jsx
 * <Col span={3}>
 *   Column
 * </Col>
 * <Col span={{ mobile: 3, tablet: 2, desktop: 2}} order={{ mobile: 3, tablet: 2, desktop: 1}}>
 *   Column
 * </Col>
 * ```
 */
const Col = React.forwardRef((props, ref) => {
    const { className, span, order, offset, style, children, gutters, ...restProps } = props;
    const spanAdaptive = React.useMemo(() => (isNumber(span) ? { mobile: span } : span), [span]);
    const orderAdaptive = React.useMemo(() => (isNumber(order) ? { mobile: order } : order), [order]);
    const offsetAdaptive = React.useMemo(() => (isNumber(offset) ? { mobile: offset } : offset), [offset]);
    const cx = useStyles(modules_a7ef704f);
    const classNames = cx(className, 'container', ...convertSpanAdaptiveToClassNames(spanAdaptive), ...convertOrderAdaptiveToClassNames(orderAdaptive), ...convertOffsetAdaptiveToClassNames(offsetAdaptive));
    const mergedStyle = {
        ...style,
    };
    // Horizontal gutter use padding
    if (gutters && gutters[0] > 0) {
        const horizontalGutter = gutters[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    // Vertical gutter use padding when gap not support
    if (gutters && gutters[1] > 0) {
        const verticalGutter = gutters[1] / 2;
        mergedStyle.paddingTop = verticalGutter;
        mergedStyle.paddingBottom = verticalGutter;
    }
    return (React.createElement("div", { "data-qa": "Col", ref: ref, className: classNames, style: { ...mergedStyle }, ...restProps }, children));
});
Col.defaultProps = {};
Col.displayName = 'Col';

export { Col };
//# sourceMappingURL=Col.js.map
